import React from 'react';
import Firebase from './index';

const FirebaseContext = React.createContext<null | Firebase>(null);

export default FirebaseContext;
